const nameInputsRegex = /^[a-zA-z]+([\s][a-zA-Z]+)*/;
const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/i;
// eslint-disable-next-line no-useless-escape
const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

export { nameInputsRegex, emailRegex, phoneRegex };
